import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import WithModal from "Components/withModal";
import classNames from "classnames";
import isNumber from "lodash/isNumber";
import isUndefined from "lodash/isUndefined";
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { NEW_SUMMARY_REPORT } from "./constants";
import SummaryReportEditor from "./summaryReportEditor";
import locale from "./summaryReportEditorPanel.locale";
export const SIZES = {
    MODAL_WIDTH: 450,
    MODAL_HEIGHT: 200
};
function SummaryReportEditorPanel(props) {
    const [show, setShow] = useState(false);
    const summaryReportIdRef = useRef(props.summaryReportId);
    const [inEditingProgress, setInEditingProgress] = useState(new Set());
    const title = useMemo(() => isUndefined(props.summaryReportId)
        ? ""
        : props.summaryReportId === NEW_SUMMARY_REPORT.Id
            ? locale.CREATE_SUMMARY_REPORT
            : locale.EDIT_SUMMARY_REPORT, [props.summaryReportId]);
    useEffect(() => {
        summaryReportIdRef.current = props.summaryReportId;
        props.summaryReportId && props.onInitialized && props.onInitialized(props.summaryReportId);
        setShow(!isUndefined(props.summaryReportId));
    }, [props.summaryReportId]);
    const handleHideModal = useCallback((e) => {
        if (e)
            props.onClose && props.onClose();
        else
            setShow(false);
    }, [props.onClose]);
    const handleClose = useCallback((summaryReportId) => {
        if (summaryReportId === summaryReportIdRef.current)
            setShow(false);
    }, []);
    const handleEditingInProgress = useCallback((inProgress, summaryReportId) => {
        setInEditingProgress(prev => {
            if (inProgress && prev.has(summaryReportId))
                return prev;
            const result = new Set(prev);
            if (inProgress)
                result.add(summaryReportId);
            else
                result.delete(summaryReportId);
            return result;
        });
    }, []);
    return (React.createElement(WithModal, { show: show, onHide: handleHideModal, contentClassName: classNames("panel-body-padding", isNumber(props.summaryReportId) &&
            inEditingProgress.has(props.summaryReportId) &&
            "no-pointer-events"), shadingColor: shadingLightestColor, className: "bg-blur", title: title, defaultWidth: SIZES.MODAL_WIDTH, defaultHeight: SIZES.MODAL_HEIGHT, isLoading: props.inProgress },
        React.createElement(SummaryReportEditor, { onHide: handleClose, onEditingInProgress: handleEditingInProgress })));
}
export default memo(SummaryReportEditorPanel);
